__turbopack_context__.v({
  "desktopPincodeWrapper": "CategorySidebar-module__0yp4VG__desktopPincodeWrapper",
  "genderOption": "CategorySidebar-module__0yp4VG__genderOption",
  "genderOptionText": "CategorySidebar-module__0yp4VG__genderOptionText",
  "genderOptionsContainer": "CategorySidebar-module__0yp4VG__genderOptionsContainer",
  "genderSelectionTitle": "CategorySidebar-module__0yp4VG__genderSelectionTitle",
  "genderSelectionWrapper": "CategorySidebar-module__0yp4VG__genderSelectionWrapper",
  "radioButton": "CategorySidebar-module__0yp4VG__radioButton",
  "separator": "CategorySidebar-module__0yp4VG__separator",
  "sidebar": "CategorySidebar-module__0yp4VG__sidebar",
});
